import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import LatestGrid from "./components/LatestGrid";
import TopicSection from "./components/TopicSection";
import IntroSection from "./components/IntroSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroCarousel />
        <CategoryEntry />
        <LatestGrid />
        <TopicSection />
        <IntroSection />
      </main>
      <Footer />
    </div>
  );
}